module.exports = __webpack_public_path__ + "static/media/data-dictionary.e05f2cfb.png";